import React from "react";
import "../styles/BillingRecapTable.css";

const ROWS = [
  {
    prestation: "Enregistrement FDA avec services gestion et agent US",
    badge: { label: "nouveau", color: "badge-blue" },
    factClient: "À la signature du devis",
    factFoodinnov: "À la réception du paiement client",
    factFoodinnovNote: "Pour le calcul du montant, appliquer le % après avoir déduit les frais Hillebrand, soit 80 €/enregistrement",
    pct: 65,
  },
  {
    prestation: "Forfait gestion Abo ENR et PN",
    badge: { label: "renouvellement", color: "badge-purple" },
    factClient: "Tous les ans, à partir du mois d'octobre",
    factFoodinnov: "À la réception du paiement client",
    factFoodinnovNote: "Pour le calcul du montant, appliquer le % après avoir déduit les frais Hillebrand, soit 80 €/enregistrement",
    pct: 60,
  },
  {
    prestation: "Conseil réglementaire",
    badge: { label: "heure ou journée", color: "badge-teal" },
    factClient: "À la fin du mois",
    factFoodinnov: "À la fin du mois",
    pct: 70.59,
  },
  {
    prestation: "Gestion déclarations CBMA TTB 2026",
    badge: null,
    factClient: "Tous les ans, à partir du mois d'octobre",
    factFoodinnov: "À la réception du paiement client",
    pct: 70.59,
  },
  {
    prestation: "Abo Veille Export",
    badge: null,
    factClient: "Tous les ans",
    factFoodinnov: "À la réception du paiement client",
    pct: 70,
  },
  {
    prestation: "Abonnement Exportalim Database",
    badge: null,
    factClient: "Tous les ans",
    factFoodinnov: "À la réception du paiement client",
    pct: 70,
  },
  {
    prestation: "Prior Notice",
    badge: null,
    factClient: "Après commande du forfait ou signature d'un devis",
    factFoodinnov: "À la réception du paiement client",
    pct: 65,
  },
];

const pctClass = (pct: number) => {
  if (pct >= 70) return "pct-green";
  if (pct >= 65) return "pct-blue";
  return "pct-orange";
};

const BillingRecapTable: React.FC = () => (
  <div className="billing-recap-wrapper">
    <div className="billing-recap-header">
      <span className="billing-recap-icon">📋</span>
      <div>
        <h3 className="billing-recap-title">Récapitulatif de facturation</h3>
        <p className="billing-recap-subtitle">
          Conditions de facturation et taux de refacturation REC / Foodinnov
        </p>
      </div>
    </div>

    <div className="billing-recap-table-container">
      <table className="billing-recap-table">
        <thead>
          <tr>
            <th className="col-prestation">Prestations</th>
            <th className="col-fact">
              Facturation client
              <span className="th-sub">par Foodinnov</span>
            </th>
            <th className="col-fact">
              Facturation Foodinnov
              <span className="th-sub">par REC</span>
            </th>
            <th className="col-pct">% Refacturation REC / Foodinnov</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row, i) => (
            <tr key={i} className={i % 2 === 0 ? "row-even" : "row-odd"}>
              <td className="cell-prestation">
                <span className="prestation-name">{row.prestation}</span>
                {row.badge && (
                  <span className={`prestation-badge ${row.badge.color}`}>
                    {row.badge.label}
                  </span>
                )}
              </td>
              <td className="cell-fact">
                <span className="fact-icon">🗓</span>
                {row.factClient}
              </td>
              <td className="cell-fact">
                <span className="fact-icon">💳</span>
                {row.factFoodinnov}
                {row.factFoodinnovNote && (
                  <span className="fact-note">{row.factFoodinnovNote}</span>
                )}
              </td>
              <td className="cell-pct">
                <span className={`pct-pill ${pctClass(row.pct)}`}>
                  {row.pct % 1 === 0 ? `${row.pct}%` : `${row.pct}%`}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <p className="billing-recap-note">
      * Les pourcentages s'entendent hors taxes. Tout paiement client reçu déclenche la refacturation dans les conditions indiquées.
    </p>
  </div>
);

export default BillingRecapTable;
